import { useReward } from "api/rewards";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { RewardForm } from "./RewardForm";
import { useStyles } from "./RewardForm.styles";

export function EditReward() {
  const classes = useStyles();
  const { message } = useMessage();
  const { useRewardData } = useReward();
  const { id: rewardID } = useParams<{ id: string }>();
  const { data: rewardData = null } = useRewardData(rewardID as string);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "rewards" }),
      path: links.rewardsList,
    },
  };

  return (
    <>
      <TopHeader
        title={
          (rewardData &&
            `${message({ id: "editReward" })} "${rewardData?.name || ""}"`) ||
          ""
        }
        clearLink={links.rewardsList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.formContainer}>
        {rewardData && (
          <RewardForm editMode rewardData={rewardData} rewardID={rewardID} />
        )}
      </div>
    </>
  );
}
